import axios from "axios";
import { attributionForSubmit } from "@/lib/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const ADMIN_TOKEN_KEY = "pw_admin_token";

const LOOKUP_KEYS = {
  Standard: "pw_standard",
  NetEntry: "pw_net_entry",
  Pro: "pw_pro",
  Facility: "pw_facility",
  Hoodie: "pw_hoodie",
  HoodieNavy: "pw_hoodie_navy",
  HoodieV2: "pw_hoodie_v2",
  Backpack: "pw_backpack",
  Paddle: "pw_paddle",
};

export function genIdempotencyKey() {
  try {
    return crypto.randomUUID();
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

export async function startCheckout({ variant, quantity = 1, name, email, variantNote, discountCode, idempotencyKey }) {
  const lookup_key = LOOKUP_KEYS[variant];
  if (!lookup_key) throw new Error("Unknown product variant");
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    quantity,
    origin_url: window.location.origin,
    name,
    email,
    variant_note: variantNote,
    attribution: attributionForSubmit(),
    discount_code: discountCode || undefined,
    idempotency_key: idempotencyKey || genIdempotencyKey(),
  });
  if (data?.checkout_url) {
    window.location.href = data.checkout_url;
  } else {
    throw new Error("No checkout URL returned");
  }
}

export async function startCartCheckout(items, discountCode, idempotencyKey) {
  const { data } = await api.post("/payments/checkout", {
    items,
    discount_code: discountCode || undefined,
    origin_url: window.location.origin,
    attribution: attributionForSubmit(),
    idempotency_key: idempotencyKey || genIdempotencyKey(),
  });
  if (data?.checkout_url) {
    window.location.href = data.checkout_url;
  } else {
    throw new Error("No checkout URL returned");
  }
}

export async function validateDiscountCode(code, items) {
  const { data } = await api.post("/payments/validate-discount", {
    code,
    items: items.map((i) => ({ lookup_key: i.lookupKey, quantity: i.quantity, variant_note: i.variantNote })),
  });
  return data;
}

export async function saveCart({ email, items, marketingConsent }) {
  const { data } = await api.post("/cart/save", {
    email,
    items: items.map((i) => ({ lookup_key: i.lookupKey, quantity: i.quantity, variant_note: i.variantNote })),
    marketing_consent: Boolean(marketingConsent),
  });
  return data;
}

export const adminApi = {
  setToken: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  getToken: () => localStorage.getItem(ADMIN_TOKEN_KEY),
  clearToken: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
  authHeader: () => {
    const t = localStorage.getItem(ADMIN_TOKEN_KEY);
    return t ? { Authorization: `Bearer ${t}` } : {};
  },
};
